import ApiService from "@/core/services/api.service";
// action types
export const ACCOUNT_VALIDATE = "accountValidate";
export const ACCOUNT_CREATE = "accountCreate";
// mutation types
export const SET_ERROR = "setError";

const state = {
  errors: {},
};

const actions = {
  [ACCOUNT_VALIDATE](context, account) {
    return new Promise(resolve => {
      ApiService.post({action:`/api/Cliente/v1/cliente/validar`}, account)
        .then(({ data }) => {
          context.commit(SET_ERROR, [] );
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"] );//response.data.errors);
          console.log(response);
        });
    });
  },
  [ACCOUNT_CREATE](context, account) {
    return new Promise(resolve => {
      ApiService.post({action:`/api/Cliente/v1/cliente/registro/`}, account)
        .then(({ data }) => {
          context.commit(SET_ERROR, data.errors );
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
}
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  }
};

export default {
  state,
  actions,
  mutations
};
